import shuffle from 'fisher-yates';
import {isMobile} from 'is-mobile';
import load from 'load.js';
import * as cookies from 'es-cookie';

/**
 * To add an adspeed slot simply include a Dom element with a class of "AdSpeed-ROS".
 *
 * We can implement the pencil and and interstitial using a similar method.
 */

//Dynamically load the ads with a cache busting random
load.js('//g.adspeed.net/ad.php?do=js&zids=96474x10-96475x10-96613-96614&oid=23463&wd=-1&ht=-1&target=_blank&cb=' + Math.random(), (error) => {
  if (error) {
    console.error(error);
  }
  const CookieName = 'AdSpeed-Interstitial';

  if (cookies.get(CookieName) !== undefined) {
    return;
  }

  cookies.set(CookieName, '1', {expires: 1});
  loadBannerAds();
  loadInterstitialAd();
  loadPencilAd();
});

function loadBannerAds() {
  const desktopZone = 96474;
  const mobileZone = 96475;
  const zoneId = isMobile() ? mobileZone : desktopZone;

  let slot = shuffle([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]);
  $('.AdSpeed-ROS').each((index, div) => {
    div.id = 'AdSpeed-ROS-' + index;
    window.AdSpeed_jQuery(div.id, zoneId, slot.pop());
  });
}

function loadInterstitialAd() {
  window.AdSpeed_jQuery('AdSpeed-ROS-interstitial', 96613, 0);

  // if (false) {//ad criteria to decide if we show the ad or not
  //   return;
  // }
  console.log('interstitial');
  setTimeout(() => interstitialDisplay(), 1000);
  setTimeout(() => interstitialHide(), 6000);
}

function interstitialDisplay() {
  console.log('display');
  let seconds = 4;
  let countdown = setInterval(function () {
    seconds--;
    $('.modal-close-counter').html(seconds);
    if (seconds <= 0) {
      clearInterval(countdown);
      $('.modal-close-counter').html('X');
    }
  }, 1000);

  $('head').addClass('is-clipped');
  $('.interstitial-ad').addClass('is-active fadeIn');
  $('.interstitial-ad .modal-content').addClass('fadeInDown');
  $('.modal-close-counter').addClass('fadeIn');
}

function interstitialHide() {
  console.log('hide');
  $('head').removeClass('is-clipped');
  $('.interstitial-ad').removeClass('fadeIn').addClass('fadeOut');
  $('.interstitial-ad .modal-content').removeClass('fadeInDown').addClass('fadeOutDown');
  setTimeout(() => $('.interstitial-ad').removeClass('is-active'), 500);
}

function loadPencilAd() {
  //Implement Pencil Ad
}



// WEBPACK FOOTER //
// ./scripts/util/AdSpeed.js